import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private readonly API = `${environment.wsUrl}email/`;

  constructor(private http: HttpClient) { }

  sendMail(json){
    return this.http.post(this.API +"contato", {json}).toPromise();
  }

  sendMailCaneta(json){
    return this.http.post(this.API + "caneta", {json}).toPromise();
  }

}
